import { render, staticRenderFns } from "./HeroTitle.vue?vue&type=template&id=5ed2375e"
import script from "./HeroTitle.vue?vue&type=script&lang=js"
export * from "./HeroTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports